<template lang="pug">
  .app(tabindex="1", ref="app", @keyup.right.space="impressNextStep", @keyup.left="impressPrevStep")
    impress-viewport(ref="impress", :steps="steps", :config="config")
</template>



<script>
  import 'vue-impress/dist/vue-impress.css'
  import LoginAndRegistration from './LoginAndRegistration'
  import AddNewRoute from './AddNewRoute'
  import Roles from './Roles'
  import Routes from './Routes'
  import Routes2 from './Routes2'
  import EditRoute from './EditRoute'
  import EditRoute2 from './EditRoute2'
  import EditRoute3 from './EditRoute3'
  import EditRoute4 from './EditRoute4'
  import EditRoute5 from './EditRoute5'
  import EditRoute6 from './EditRoute6'
  import EditRoute7 from './EditRoute7'
  import EditRoute9a from './EditRoute9a'
  import EditRoute9b from './EditRoute9b'
  import EditRoute10 from './EditRoute10'


export default {

  components: {
    LoginAndRegistration,
    AddNewRoute,
    Roles,
    Routes,
    Routes2,
    EditRoute,
    EditRoute2,
    EditRoute3,
    EditRoute4,
    EditRoute5,
    EditRoute6,
    EditRoute7,
    EditRoute9a,
    EditRoute9b,
    EditRoute10
  },

  methods: {
    impressPrevStep() {
      this.$refs.impress.prevStep()
    },
    impressNextStep() {
      this.$refs.impress.nextStep()
    },
  },

  mounted() {
    this.$refs.app.focus()
  },

  data() {
    return {
      config: {
        width: 'auto', // required
        height: 'auto', // required
        transitionDuration: 1200, 
        //default: 1000,
        //perspective: 800, // default 1000

        /* in fullscreen, only first viewport instance work, others are meaningless
         * 若全屏模式，则只有第一个viewport的实例可以正常工作，大概...
         * 全屏的话，第一个实例会占满窗口，就像impress.js的例子一样，他实例也没有意义 */
        fullscreen: false, // default true
      },
      steps: [{
        x: -500,
        y: 0,
        /* string content
        * 可以传入普通文本
        */
        content: 'Vaihda sivua vasemmalla ja oikealla nuolinäppäimellä',
        id: 'firstStep'
      }, {
        x: 500,
        y: 400,
        scale: 1,
        /* content could be vue component
        * 可以传入vue组件
        */
        component: LoginAndRegistration,
        /* props is optional
        * props按需传，没有可不写
        */
        props: {
          myname: 'abc',
        },
        transitionDuration: 1000,
        // transitionTimingFunction: 'linear', // default 'ease'
      }, {
        x: 1000,
        y: -200,
        z: 200,
        //rotateX: 80,
        scale: 1,
        component: Roles,
        id: 'xRotateStep',
      }, {
        x: 1000,
        y: -1000,
        //rotate: 720,
        component: Routes,
        id: 'zRotateStep',
      }, {
        x: 0,
        y: 1000,
        z: 900,
        scale: 0.7,
        component: AddNewRoute,
        id: 'overview',
      }, {
        x: -1000,
        y: -1000,
        //z: 900,
        scale: 1,
        component: Routes2,
        id: 'routes2',
      }, {
        x: -2000,
        y: -800,
        //z: 900,
        scale: 1,
        component: EditRoute,
        id: 'editRoute',
      }, {
        x: -3000,
        y: -800,
        //z: 900,
        scale: 0.9,
        component: EditRoute2,
        id: 'editRoute2',
      }, {
        x: -4000,
        y: 0,
        //z: 900,
        scale: 0.7,
        component: EditRoute3,
        id: 'editRoute3',
      }, {
        x: -5500,
        y: 0,
        //z: 900,
        scale: 0.7,
        component: EditRoute4,
        id: 'editRoute4',
      }, {
        x: -5500,
        y: 2000,
        //z: 900,
        scale: 0.7,
        component: EditRoute5,
        id: 'editRoute5',
      }, {
        x: -5500,
        y: 3500,
        //z: 900,
        scale: 0.7,
        component: EditRoute6,
        id: 'editRoute6',
      }, {
        x: -5500,
        y: 6500,
        //z: 900,
        scale: 0.7,
        component: EditRoute7, 
        id: 'editRoute7',
      }, {
        x: -5500,
        y: 5500,
        //z: 900,
        scale: 0.7,
        component: EditRoute9a, 
        id: 'editRoute9a',
      }, {
        x: -5500,
        y: 7000,
        //z: 900,
        scale: 0.7,
        component: EditRoute9b, 
        id: 'editRoute9b',
      },, {
        x: 6000,
        y: 7000,
        //z: 900,
        scale: 0.7,
        component: EditRoute10, 
        id: 'editRoute10',
      }],
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
